import { useNavigate } from 'react-router-dom'
import { Receipt, Users } from 'lucide-react'
import { Segmentado } from './ui/base'

/** Ventas y Clientes se presentan como una sola sección con dos
 *  pestañas: están relacionados —toda venta tiene un cliente— y no
 *  necesitan cada uno su propio lugar en la barra principal. */
export function SubNavVentas({ activa }: { activa: 'ventas' | 'clientes' }) {
  const navegar = useNavigate()

  return (
    <Segmentado
      className="mb-5"
      valor={activa}
      onChange={(v) => navegar(v === 'ventas' ? '/ventas' : '/clientes')}
      variante="marcado"
      opciones={[
        { valor: 'ventas', etiqueta: 'Ventas', icono: <Receipt className="size-4" /> },
        { valor: 'clientes', etiqueta: 'Clientes', icono: <Users className="size-4" /> },
      ]}
    />
  )
}
